import React, { MouseEvent } from 'react';
import CaretIcon from '@zola/zola-ui/src/components/SvgIcons/CaretV2';

import { trackNavigationClicked } from '@zola/tracking-contracts/src/tracking';
import { transformNavigationLevel } from 'util/trackNavigationClickedHelpersV2';

import type { PrimaryNavItemType, PrimaryNavType, SecondaryNavType } from '../../../preauthNavData';

import {
  Container,
  Title,
  Link,
  MenuParent,
  liBaseStyles,
  StyledLinkV2,
  UnorderedList,
} from './MobileNavMenuLinkGroup.styles';

export type MobileNavMenuLinkGroupsProps = {
  isConsolidatedMwebNav: boolean;
  linkGroups: PrimaryNavType;
  setMenu: (newData: PrimaryNavType) => void;
  setMenuItemIndex: (index: number) => void;
  setSubMenu: (newData: SecondaryNavType) => void;
  className?: string;
  trackingIndexOffset?: number;
};

const MobileNavMenuLinkGroup = ({
  isConsolidatedMwebNav,
  linkGroups,
  setMenu,
  setMenuItemIndex,
  setSubMenu,
  className,
  trackingIndexOffset = 0,
}: MobileNavMenuLinkGroupsProps): JSX.Element => {
  const handleTrackNavigationClicked = (group: PrimaryNavItemType, groupIndex: number) => {
    trackNavigationClicked({
      business_category: group.businessCategory || 'UNATTRIBUTED',
      business_unit: group.businessUnit || 'UNATTRIBUTED',
      navigation_type: 'GLOBAL',
      ...(isConsolidatedMwebNav
        ? {
            navigation_level_1: transformNavigationLevel(group.label),
            navigation_level_1_position: trackingIndexOffset + groupIndex + 1,
          }
        : {
            navigation_level_1: transformNavigationLevel(linkGroups.title),
            navigation_level_1_position: linkGroups.position,
            navigation_level_2: transformNavigationLevel(group.label),
            navigation_level_2_position: groupIndex + 1,
          }),
    });
  };

  const handleClick = (
    e: MouseEvent<HTMLAnchorElement>,
    group: PrimaryNavItemType,
    groupIndex: number
  ) => {
    e.preventDefault();
    setMenu(linkGroups);
    setMenuItemIndex(groupIndex);
    setSubMenu(group.subnav || []);
  };

  return (
    <Container className={className} isConsolidatedMwebNav={isConsolidatedMwebNav}>
      {!isConsolidatedMwebNav && linkGroups.title && <Title>{linkGroups.title}</Title>}
      <UnorderedList isConsolidatedMwebNav={isConsolidatedMwebNav}>
        {linkGroups.nav.map((group, groupIndex) => {
          if (!isConsolidatedMwebNav && group.subnav && group.subnav.length > 0) {
            return (
              <li key={groupIndex} css={liBaseStyles}>
                <MenuParent href={group.path} onClick={(e) => handleClick(e, group, groupIndex)}>
                  <span>{group.label}</span>
                  {group.subnav && <CaretIcon direction="right" showTitle={false} />}
                </MenuParent>
              </li>
            );
          }
          return (
            <li key={groupIndex} css={liBaseStyles}>
              {isConsolidatedMwebNav ? (
                <StyledLinkV2
                  href={group.path}
                  noTextTransform
                  noUnderline
                  onClick={() => handleTrackNavigationClicked(group, groupIndex)}
                  sizes="small"
                  subtle
                >
                  {group.icon} {group.label}
                </StyledLinkV2>
              ) : (
                <Link
                  href={group.path}
                  onClick={() => handleTrackNavigationClicked(group, groupIndex)}
                >
                  {group.label}
                </Link>
              )}
            </li>
          );
        })}
      </UnorderedList>
    </Container>
  );
};

export default MobileNavMenuLinkGroup;
